(() => {
  const callback = async () => {
    const YOTPO_APP_KEY = 'HuIgnH7XiPv6ba8rxZYGEhWKWx7NAIJSKqu7Rt5d';

    const fetchSummary = async ({ productId }) => {
      if (!productId) return;

      try {
        const request = await fetch(
          `https://api-cdn.yotpo.com/v1/widget/${YOTPO_APP_KEY}/products/${productId}/reviews.json?per_page=1`,
          {
            method: 'GET',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          },
        );

        const data = await request.json();
        const { bottomline } = data?.response ?? {};

        return mapSummary(bottomline);
      } catch (error) {
        console.error(error);
      }
    };

    const mapSummary = (bottomline) => {
      if (!bottomline) return;

      const {
        average_score: averageScore,
        total_review: totalReviews,
        custom_fields_bottomline: customFields,
      } = bottomline;

      const formattedScore = averageScore?.toFixed(1);

      const sizingAverageValue = customFields?.['--67843']?.['average_score'];

      return {
        score: formattedScore,
        starsHtml: getStarsHtml(formattedScore),
        totalReviews,
        sizing: sizingAverageValue,
      };
    };

    const getStarsHtml = (score) => {
      if (!score) return;

      const filledStar =
        '<svg class="icon--star-filled" width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m8 0 1.796 5.528h5.813l-4.703 3.416 1.796 5.528L8 11.056l-4.702 3.416 1.796-5.528L.392 5.528h5.812L8 0Z" fill="#121212"/></svg>';
      const emptyStar =
        '<svg class="icon--star-empty" width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m8 1.352 1.399 4.305.094.289h4.83l-3.662 2.66-.246.179.094.288 1.399 4.305-3.662-2.66L8 10.539l-.246.179-3.662 2.66 1.4-4.305.093-.288-.246-.179-3.662-2.66h4.83l.094-.289L8 1.352Z" stroke="#121212" stroke-width=".836"/></svg>';
      const halfStar =
        '<svg class="icon--star-half" width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 0V11.056l-4.702 3.416 1.796-5.528L.392 5.528h5.812L8 0Z" fill="#121212"/><path d="m8 1.352 1.399 4.305.094.289h4.83l-3.662 2.66-.246.179.094.288 1.399 4.305-3.662-2.66L8 10.539l-.246.179-3.662 2.66 1.4-4.305.093-.288-.246-.179-3.662-2.66h4.83l.094-.289L8 1.352Z" stroke="#121212" stroke-width=".836"/></svg>';

      const starsHtml = [...Array(5)]
        .map((_, idx) => {
          const value = score - idx;

          if (value >= 0.5 && value < 1) return halfStar;
          if (value >= 1) return filledStar;
          return emptyStar;
        })
        .join('');

      return starsHtml;
    };

    const toggleClass = ({ element, className, value }) => {
      if (!element) return;

      element.classList.toggle(className, value);
    };

    const setInnerHtml = ({ element, content }) => {
      if (!element) return;

      element.innerHTML = content ?? '';
    };

    const loadSummary = async ({ productId }) => {
      const data = await fetchSummary({ productId });

      const { score, starsHtml, totalReviews, sizing } = data ?? {};

      if (totalReviews === 0) {
        toggleClass({ element: section, className: 'hidden', value: true });
        return;
      }

      const hasRatingData = score && starsHtml && totalReviews;
      toggleClass({ element: elements.ratingWrapper, className: 'hidden', value: !hasRatingData });

      if (hasRatingData) {
        setInnerHtml({ element: elements.score, content: score });
        setInnerHtml({ element: elements.stars, content: starsHtml });

        const totalReviewsLocale =
          locale.totalReviews && `(${locale.totalReviews.replace('[number]', `<span>${totalReviews}</span>`)})`;
        setInnerHtml({ element: elements.totalReviews, content: totalReviewsLocale });
      }

      const hasSizingData = sizing;
      toggleClass({ element: elements.sizingWrapper, className: 'hidden', value: !hasSizingData });

      if (hasSizingData) {
        setInnerHtml({ element: elements.sizingTitle, content: locale.sizing });
        setInnerHtml({ element: elements.sizingLegendItemSmall, content: locale.small });
        setInnerHtml({ element: elements.sizingLegendItemTrue, content: locale.trueToSize });
        setInnerHtml({ element: elements.sizingLegendItemBig, content: locale.big });
        setInnerHtml({ element: elements.sizingProgressBar, content: '' });

        const item = document.querySelector(`${selectors.sizingLegendItem}[data-value="${sizing}"]`);
        toggleClass({ element: item, className: 'active', value: true });
      }
    };

    const scrollToAllReviews = () => {
      const styles = getComputedStyle(document.documentElement);
      const headerOffset = styles.getPropertyValue('--header-offset')?.replace('px', '') ?? 0;

      const targetPostition =
        elements.allReviewsSection.getBoundingClientRect().top + document.documentElement.scrollTop - headerOffset;

      window.scrollTo({ behavior: 'smooth', top: targetPostition });
    };

    const selectors = {
      allReviewsSection: '.product-reviews',
      section: '.product-reviews-summary:not(.initialized)',
      ratingWrapper: '.product-reviews-summary__rating',
      score: '.product-reviews-summary__average-score',
      stars: '.product-reviews-summary__average-stars',
      totalReviews: '.product-reviews-summary__total-reviews',
      sizingWrapper: '.product-reviews-summary__sizing',
      sizingTitle: '.product-reviews-summary__sizing-title',
      sizingProgressBar: '.product-reviews-summary__sizing-progress-bar',
      sizingLegend: '.product-reviews-summary__sizing-legend',
      sizingLegendItem: '.product-reviews-summary__sizing-legend-item',
    };

    const section = document.querySelector(selectors.section);
    if (!section) return;

    const elements = {
      allReviewsSection: document.querySelector(selectors.allReviewsSection),
      ratingWrapper: section.querySelector(selectors.ratingWrapper),
      score: section.querySelector(selectors.score),
      stars: section.querySelector(selectors.stars),
      totalReviews: section.querySelector(selectors.totalReviews),
      sizingWrapper: section.querySelector(selectors.sizingWrapper),
      sizingTitle: section.querySelector(selectors.sizingTitle),
      sizingProgressBar: section.querySelector(selectors.sizingProgressBar),
      sizingLegend: section.querySelector(selectors.sizingLegend),
      sizingLegendItemSmall: section.querySelector(`${selectors.sizingLegendItem}[data-value="1"]`),
      sizingLegendItemTrue: section.querySelector(`${selectors.sizingLegendItem}[data-value="2"]`),
      sizingLegendItemBig: section.querySelector(`${selectors.sizingLegendItem}[data-value="3"]`),
    };

    const { productId, locale } = window.themeComponents.snippets['product-reviews-summary-ds'] ?? {};

    if (!productId || !locale) {
      section.remove();
      return;
    }

    toggleClass({ element: section, className: 'initialized', value: true });

    loadSummary({ productId });

    [elements.score, elements.stars, elements.totalReviews].filter(Boolean).forEach((element) => {
      element.addEventListener('click', scrollToAllReviews);
    });
  };

  window.addEventListener('DOMContentLoaded', callback);
})();
